// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".touch-header{margin-bottom:60px;height:90px;position:relative;z-index:40;box-shadow:0 -2px 20px 0 rgba(0,0,0,.1)}.touch-header__logo{flex:1 1 0!important;height:45px!important;display:inline-block;padding-top:20px;top:-20px;position:relative;margin-right:0}.touch-header__back,.touch-header__lang{width:150px}", ""]);
// Exports
module.exports = exports;
